import { Stack } from '@mui/material'

import { IframeProps } from './types'

export const Iframe = ({ height, src }: IframeProps): JSX.Element => (
  <Stack
    direction='row'
    sx={{
      '& iframe': {
        border: 'none',
        minHeight: `${height}px`,
        width: '100%',
      },
      alignItems: 'center',
      pt: 2,
      px: 2,
    }}
  >
    <iframe src={src}></iframe>
  </Stack>
)
